import { Directive } from '@angular/core';

@Directive({
  selector: '[appFormLabel]',
  host: {
    'class': 'block mb-2 text-sm font-medium text-black'
  },
  standalone: true
})
export class FormLabelDirective {

  constructor() { }

}
